import React from 'react';

export default function Help() {
  return (
    <div className="Help">
      <h2>FAQ</h2>

      <h3>Porque é que a coluna «Calculado» pode ser diferente do valor tabelado?</h3>
      <p>
        Os valores da colunas <strong>Calculadas</strong> são derivados de uma formula
        que tem em conta as contribuições calóricas de cada macro nutriente que o compõem.
        Como tal muitas vezes difere do valor tabelado. Esta diferença é apresentada por baixo.
        A vermelho se o valor calculado for menor, a verde se o valor calculado for maior.
      </p>

      <h3>Fórmula utilizada para calcular as calorias</h3>
      <p>
        O site usa os factores de conversão de Atwater (os mesmos usados para a
        declaração nutricional no <a rel="noreferrer" target="_blank" href="https://eur-lex.europa.eu/eli/reg/2011/1169/oj/eng">
          Regulamento (UE) n.º 1169/2011. Anexo XIV
        </a>).
      </p>
      <ul>
        <li>Lípidos: 9 kcal por grama</li>
        <li>Hidratos de carbono: 4 kcal por grama</li>
        <li>Proteínas: 4 kcal por grama</li>
        <li>Fibra: 2 kcal por grama</li>
        <li>Álcool: 7 kcal por grama</li>
        <li>Sal: 0 kcal por grama</li>
      </ul>
      <p className="Help-formula">
        Kcal = (lípidos[g] × 9) <br/>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ (hidratos de carbono[g] × 4) <br/>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ (proteínas[g] × 4) <br/>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ (fibra[g] × 2) <br/>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ (álcool[g] × 7) <br/>
      </p>
    </div>
  );
}
